import { createActionTypes } from "@helpers/redux-helpers";

export const createLivestreamActionTypes =
  createActionTypes("livestreams/create");

export const updateLivestreamActionTypes =
  createActionTypes("livestreams/update");
export const updateLivestreamGoalActionTypes = createActionTypes(
  "livestreams/update/goal",
);
export const deleteLivestreamGoalActionTypes = createActionTypes(
  "livestreams/delete/goal",
);

export const endLivestreamActionTypes = createActionTypes("livestreams/end");

export const joinLivestreamActionTypes = createActionTypes("livestreams/join");
export const leaveLivestreamActionTypes =
  createActionTypes("livestreams/leave");

export const getLivestreamsActionTypes = createActionTypes(
  "livestreams/get/list",
);
export const getLivestreamsPortionActionTypes = createActionTypes(
  "livestreams/get/portion/list",
);

export const resetLivestreamsActionType = "livestreams/reset";

export const sendMessageActionTypes = createActionTypes(
  "livestreams/message/send",
);

export const getMessagesActionTypes = createActionTypes(
  "livestreams/messages/get",
);

export const getParticipantsActionTypes = createActionTypes(
  "livestreams/participants/get",
);

export const getTopTippersActionTypes = createActionTypes(
  "livestreams/top-tippers/get",
);
export const getNewMessageActionTypes = createActionTypes(
  "livestreams/message/get/new",
);

export const getNewTipActionTypes = createActionTypes(
  "livestreams/tips/get/new",
);

export const getLivestreamDetailsActionTypes = createActionTypes(
  "livestreams/details/get",
);

export const getUpdatedLivestreamDetailsActionTypes = createActionTypes(
  "livestreams/updated/details/get",
);

export const getParticipantsUpdateActionTypes = createActionTypes(
  "livestreams/updated/participants/get",
);

export const livestreamEndedActionTypes =
  createActionTypes("livestreams/ended");

export const changeParticipantRoleActionTypes = createActionTypes(
  "livestreams/change/participants/role",
);

export const deleteMessageActionTypes = createActionTypes(
  "livestreams/messages/delete",
);

export const handleDeleteMessageActionTypes = createActionTypes(
  "livestreams/handle/messages/delete",
);

export const handleDeleteAllParticipantMessagesActionTypes = createActionTypes(
  "livestreams/handle/messages/all/delete",
);

export const handleBanParticipantActionTypes = createActionTypes(
  "livestreams/handle/participant/ban",
);

export const handleMuteParticipantActionTypes = createActionTypes(
  "livestreams/handle/participant/mute",
);

export const handleInviteFromStreamerToViewerActionsTypes = createActionTypes(
  "livestreams/handle/invite/streamer/to/viewer",
);

export const deleteAllParticipantMessagesActionTypes = createActionTypes(
  "livestreams/messages/all/delete",
);

export const banParticipantActionTypes = createActionTypes(
  "livestreams/participant/ban",
);
export const muteParticipantActionTypes = createActionTypes(
  "livestreams/participant/mute",
);
export const reportStreamActionTypes = createActionTypes("livestreams/report");

export const resetRoleWasChangedFlagActionType =
  "livestreams/reset/role/changed";

export const setTipsListActionType = "livestreams/tips/list/set";
export const resetActiveStreamActionType = "livestreams/activeStream/reset";
export const updateLivestreamPreviewImageActionTypes = createActionTypes(
  "livestreams/preview/update",
);
export const unmuteMeActionType = "livestreams/activeStream/unmuteMe";

export const getInviteListActionTypes = createActionTypes(
  "livestreams/invite/list/get",
);

export const inviteParticipantActionTypes = createActionTypes(
  "livestreams/invite/participant",
);

export const makeButtonInvitableActionType =
  "livestreams/invite/button/invitable";

export const acceptInviteActionTypes = createActionTypes(
  "livestreams/invite/accept",
);

export const rejectInviteActionTypes = createActionTypes(
  "livestreams/reject/accept",
);

export const rejectAllActionTypes = createActionTypes(
  "livestreams/invites/reject/all",
);

export const requestInviteToCoStreamingActionTypes = createActionTypes(
  "livestreams/request/co-streaming",
);

export const startSpinTheBottleActionTypes = createActionTypes(
  "livestreams/games/start/spin-the-bottle",
);

export const makeCoStreamerAViewerActionTypes = createActionTypes(
  "livestreams/make/coStreamer/to/viewer",
);

export const endSpinTheBottleActionTypes = createActionTypes(
  "livestreams/games/end/spin-the-bottle",
);

export const spinTheBottleActionTypes = createActionTypes(
  "livestreams/games/spin/spin-the-bottle",
);

export const updateSpinTheBottleActionType =
  "livestreams/games/update/spin-the-bottle";

export const handleHostAcceptedRequestToCoStreamingActionTypes =
  createActionTypes("livestreams/request/accepted/co-streaming");

export const handleChangeCoStreamerRoleToViewerActionTypes = createActionTypes(
  "livestreams/change/role/to/viewer",
);

export const handleCoStreamerStartsStreamActionTypes = createActionTypes(
  "livestreams/co-streamer/starts/stream",
);
